// extracted by mini-css-extract-plugin
module.exports = {"pre-approved-container":"pre-approved_pre-approved-container__uTx7p"};